import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MatSlideToggleModule,
  MatInputModule,
  MatRippleModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatButtonModule,
  MatCheckboxModule,
  MatMenuModule,
  MatToolbarModule,
  MatGridListModule,
  MatListModule,
  MatStepperModule,
  MatTabsModule,
  MatButtonToggleModule,
  MatIconModule,
  MatFormFieldModule,
  MatAutocompleteModule,
  MatCardModule,
  MatPaginatorModule,
  MatDialogModule,
  MatRadioModule,
  MatProgressSpinnerModule
} from '@angular/material';


import {PlatformModule} from '@angular/cdk/platform';
import {ObserversModule} from '@angular/cdk/observers';

@NgModule({
  exports: [
    MatSlideToggleModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatInputModule,
    MatRippleModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatButtonModule,
    MatCheckboxModule,
    MatMenuModule,
    MatToolbarModule,
    MatGridListModule,
    MatListModule,
    MatStepperModule,
    MatTabsModule,
    MatButtonToggleModule,
    MatIconModule,
    MatFormFieldModule,
    MatCardModule,
    MatPaginatorModule,
    MatRadioModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
  MatDialogModule
,    
    ObserversModule,
    PlatformModule
  ]
})
export class MaterialModule { }



// WEBPACK FOOTER //
// ./src/app/material/material.module.ts